import { bootMarketplaceXSelectLivewire } from '../marketplace/x-select-livewire.js';

bootMarketplaceXSelectLivewire();

// ── Grid / list view toggle ───────────────────────────────────────────────────
// Pure client-side (localStorage) so switching views never hits Livewire. The
// preference is re-applied after every Livewire DOM update so filtering /
// paginating doesn't reset it.

const VIEW_KEY = 'marketplace-view';

function currentView() {
  // default view is list; only an explicit 'grid' preference switches it
  return localStorage.getItem(VIEW_KEY) === 'grid' ? 'grid' : 'list';
}

function applyView() {
  const view = currentView();
  document.querySelectorAll('.marketplace-products').forEach((c) => {
    c.classList.toggle('is-list', view === 'list');
  });
  document.querySelectorAll('.marketplace-view-toggle__btn').forEach((b) => {
    b.classList.toggle('is-active', b.dataset.view === view);
  });
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest?.('.marketplace-view-toggle__btn');
  if (!btn) return;
  localStorage.setItem(VIEW_KEY, btn.dataset.view === 'list' ? 'list' : 'grid');
  applyView();
});

document.addEventListener('DOMContentLoaded', applyView);
document.addEventListener('livewire:navigated', applyView);
document.addEventListener('livewire:init', () => {
  // re-apply right after Livewire finishes morphing the DOM
  window.Livewire?.hook?.('commit', ({ succeed }) => {
    succeed(() => applyView());
  });
});

applyView();
